<script lang="ts">
    import Card from "./Card.svelte";

    export let subjects;
    export let manager;
    export let targetId;
    export let languages;
</script>

<div class="module column">
    <div class="subject-flex">
        {#each subjects as subject}
            <div class="subject card">
                <Card  languages={languages} on:cardClick id={subject.id} manager={manager} targetId={targetId}/>
            </div>
        {/each}
    </div>
</div>

<style>

    .module{min-width: 130px}

    .subject-flex{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        row-gap: 10px;
        justify-content: center;
    }
</style>


